import { Box, Typography, useTheme } from "@mui/material";
import { Property } from "../../../types";
import InfoCell from "../../../../common/components/ui-kit/info-cell";

export default function PropertyHospitalityInfo({
  property,
}: Readonly<{
  property: Property;
}>) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        width: "100%",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Typography
          sx={theme.nawy.typography.english.variants.body.md.semibold}
        >
          Location
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "40px",
            justifyContent: "start",
          }}
        >
          <InfoCell
            title="Coordinates"
            description={
              property.latitude && property.longitude
                ? `${property.latitude}, ${property.longitude}`
                : "N/A"
            }
          />
        </Box>
      </Box>
    </Box>
  );
}
